import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let items = state.get('items') || Map();

    action.ids.forEach((id) => {
        items = items.set(
            id,
            (items.get(id) || Map()).set('state', 'IN_PROGRESS')
        );
    });

    return state.set('items', items);
}

export function error(state, action) {
    let items = state.get('items') || Map();

    action.ids.forEach((id) => {
        items = items.set(
            id,
            (items.get(id) || Map())
                .set('state', 'ERROR')
                .set('errors', fromJS(action.errors))
        );
    });

    return state.set('items', items);
}

export function finish(state, action) {
    let items = state.get('items') || Map();

    action.competitions.forEach((competition) => {
        competition.state = 'FINISHED';

        items = items.set(
            id,
            fromJS(competition)
        );
    });

    return state.set('items', items);
}
